const routes = {
  rates: 'Taxas',
  parents: 'Pais',
  newScenario: 'Novo cenário',
  viewSites: 'Visualizar locais',
  sites: 'Locais',
  attributes: 'Atributos',
  suppliers: 'Fornecedores',
  updateSupplier: 'Atualizar Fornecedor',
  createSupplier: 'Criar fornecedor',
  shuttles: 'Transporte',
  updateShuttle: 'Atualizar Transporte',
  createShuttle: 'Crie um veículo para o outro',
  fares: 'Tarifas',
  updateFare: 'Atualizar tarifa',
  createFare: 'Criar tarifa',
  services: 'Serviços',
  updateService: 'Atualizar Serviço',
  createService: 'Crie um serviço',
  users: 'Usuários',
  updateUser: 'Atualizar Usuário',
  createUser: 'Criar usuário',
  vehicles: 'Veículos',
  updateVehicle: 'Atualizar Veículo',
  createVehicle: 'Crie o Veículo',
  areas: 'Zonas',
  updateArea: 'Atualizar zona',
  createArea: 'Criar zona',
  drivers: 'Motoristas',
  updateDriver: 'Atualizar Motorista',
  createDriver: 'Criar Motorista',
  playground: 'Recreio',
  support: 'Suporte',
  parameters: 'Parâmetros',
  createParameter: 'Criar parâmetro',
  analytics: 'Analítica',
  settings: 'Configurações',
  liveMap: 'Mapa em tempo real',
  driverShifts: 'Turnos do motorista',
  createDriverShift: 'Crie um turno de motorista único',
  createMultipleDriverShifts: 'Crie Turnos de Motoristas Múltiplos',
  passengers: 'Passageiros',
  students: 'Alunos',
  employees: 'Funcionários',
  editShuttle: 'Editar transporte',
  updatePassenger: 'Editar passageiro',
  createPassenger: 'Novo passageiro',
  onlineDrivers: 'Motoristas on-line',
  trips: 'Viagens',
  productionTrips: 'Viagens de Produção',
  reservations: 'Reservas',
  editReservation: 'Editar reserva',
  createReservation: 'Criar reserva',
  createQuick: 'Criação Rápida',
  timeline: 'Linha do tempo',
  home: 'Controle da missão',
  import: 'Carregar dados',
  reports: 'Relatórios',
  shuttleReports: 'Relatórios de transporte',
  locations: 'Localização',
  createLocation: 'Criar Localização',
  editLocation: 'Atualizar Localização',
  profiles: 'Perfis',
  shifts: 'Turnos',
  createShift: 'Criar Turno',
  updateShift: 'Atualizar Turno',
  agentHome: 'Agente',
  createExtraService: 'Serviço extra em Creta',
  updateExtraService: 'Atualizar serviço extra',
  extraServices: 'Serviços extras',
  tripsPaxReports: 'Resumo de Viagens / Passageiros',
  uniqueDriversReport: 'Motoristas únicos por dia',
  permissions: 'Funções e Permissões',
  createJob: 'Criar reserva',
  quickJob: 'Reserva rápida',
  onboarding: 'Construtor de cenários - NEMT',
  holidays: 'Feriados',
  blacklist: 'Lista Negra de Cartões',
  integrations: 'Integrações',
  automations: 'Automações',
  jobsCalendar: 'Calendário de Reservas',
  caregivers: 'Cuidadores',
  customRules: 'Regras Personalizadas',
  billReports: 'Relatório de Cobrança',
  performanceOverview: 'Visão geral de desempenho',
  facilities: 'Instalações',
  roiSimulation: 'Simulação de ROI',
};

export default routes;
